export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-interpolate/src/constant.js
// module id = ./node_modules/d3-interpolate/src/constant.js
// module chunks = vendor